import CryptoJS from 'crypto-js';
import APP_CONFIG from "../config";

const SECRET_KEY = APP_CONFIG.MY_SECRET_KEY; // idéalement dans .env

export const secureStorage = {
    set(key, value) {
        const encryptedKey = CryptoJS.SHA256(key).toString();
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
        localStorage.setItem(encryptedKey, encryptedValue);
    },

    get(key) {
        const encryptedKey = CryptoJS.SHA256(key).toString();
        const encryptedValue = localStorage.getItem(encryptedKey);
        if (!encryptedValue) return null;
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch {
            return null;
        }
    },

    remove(key) {
        const encryptedKey = CryptoJS.SHA256(key).toString();
        localStorage.removeItem(encryptedKey);
    },

    clear() {
        localStorage.clear();
    }
};
